module.exports = __webpack_public_path__ + "img/2.0e0e12c5.jpg";